@if (showOutboundFeedsByARAccount) {
  <div class="col-md-6 mt-5">
    @if (allowDeselectAndAddMore) {  
        <div>
          <dd>
            <inm-checkbox
              class="outbound-feed-checkbox-layout"
              [checked]="showOutboundFeedsByARAccount"
              (change)="isCopyParentOutboundFeeds($event)"
              >
              {{ 'common.copy_all' | staticContent }}
            </inm-checkbox>
          </dd>
        </div>
    }
  </div>
}

<inm-panel>
  @if (!outboundFeedsValueLoaded) {
    <span class="obf-title">{{ 'accounts.create.obf.title' | staticContent }}</span>
  }
  @if (!outboundFeedsValueLoaded) {
    <div class="row">
      <div class="col-md-6">
        <div class="inm-textinput">
          <dt class="inm-subheading inm-mid-blue-text">{{ getAccountCodeAndName().accountInfo.code.label }}</dt>
          <dd class="inm-textinput__input inm-disabled">{{ getAccountCodeAndName().accountInfo.code.key }}</dd>
        </div>
      </div>
      <div class="col-md-6">
        <div class="inm-textinput">
          <dt class="inm-subheading inm-mid-blue-text">{{ getAccountCodeAndName().accountInfo.name.label }}</dt>
          <dd class="inm-textinput__input inm-disabled">{{ getAccountCodeAndName().accountInfo.name.key }}</dd>
        </div>
      </div>
    </div>
  }
  <ng-content></ng-content>

  <form name="form" role="form" [formGroup]="form" novalidate>
    @if (obfs) {
      <div formArrayName="obfs">
        @for (obf of obfs.controls; track obf; let i = $index) {
          <div>
            <inm-panel [title]="getPanelTitle(i)">
              @if (allowDeselectAndAddMore) {
                <div class="obf-deselect">
                  <button class="float-end" inm-button text="cancel" (click)="deleteOutboundFeed(i)">
                    {{ 'buttons.deselect' | staticContent }}
                  </button>
                </div>
              }
              <ng-container>
                <div
              [ngClass]="
                allowDeselectAndAddMore ? 'expandPanel expandPanel-withButton' : 'expandPanel expandPanel-withoutButton'
              "
                  >
                  <inm-icon
                    (click)="expandPanelAction(i)"
                    [name]="expand[i] ? iconNames.ChevronUp : iconNames.ChevronDown"
                    size="small"
                    [color]="iconColors.Grey"
                  ></inm-icon>
                </div>
              </ng-container>
              <div [formGroupName]="i" class="pt-3" [ngClass]="{ collapsed: expand[i] }">
                <inm-outbound-feed-form
                  [outboundFeedFormGroup]="obf"
                  [outboundFeedsValueLoaded]="true"
                ></inm-outbound-feed-form>
              </div>
            </inm-panel>
          </div>
        }
      </div>
    }
  </form>
  @if (showErrorMessage) {
    <div class="outbound-feed-duplicate-message">
      <inm-icon name="{{ iconNames.Warning }}" color="StatusOrange"></inm-icon>
      {{ 'accounts.create.obf.duplicate_outbound_feed' | staticContent }}
    </div>
  }
  <inm-panel-actions>
    @if (allowDeselectAndAddMore) {
      <button inm-button text="cancel" (click)="addMoreOutboundFeed()">
        {{ 'buttons.add_obf' | staticContent }}
      </button>
    }
    @if (allowCancelAndNext) {
      <button inm-button text="cancel" (click)="cancel()">
        {{ 'buttons.cancel' | staticContent }}
      </button>
    }
    @if (allowCancelAndNext) {
      <button
        inm-button
        kind="primary"
        (click)="createOutboundFeed()"
      [disabled]="
        (form.valid || form.status === outboundFeedFormStatus.DISABLED) && !checkMandatoryOutboundFeedsValue()
      "
        >
        {{ 'buttons.next' | staticContent }}
        @if (
          (form.valid || form.status === outboundFeedFormStatus.DISABLED) && !this.checkMandatoryOutboundFeedsValue()
          ) {
          <inm-icon
            class="icon ms-2"
            name="Info"
            size="small"
            [tooltip]="getTooltipText()"
            >
          </inm-icon>
        }
      </button>
    }
  </inm-panel-actions>
</inm-panel>
